function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// import appApis from '@/services/services'

import tasks from '@/js/tasks';
import axios from 'axios';
import setupInterceptors from '@/services/setupInterceptors';
var configuration = JSON.parse(process.env.VUE_APP_API_GTW_CONFIG);
//console.log(configuration)
// declare service gtw
var appApisGTW = null;
if (!configuration['visualization']) {
  appApisGTW = axios.create({
    baseURL: 'http://localhost{PORT}'.replace('{PORT}', ':8091')
  });
} else {
  appApisGTW = axios.create({
    baseURL: process.env.VUE_APP_API_GTW.replace('{PORT}', ':8091')
  });
}
var beforeMiddleware = function beforeMiddleware(config) {
  // tasks.getUserInfo()
  config.headers['Authorization'] = 'Bearer ' + window.userInfo.accessToken;
  return config;
};

//appApisGTW.before(beforeMiddleware)
setupInterceptors(appApisGTW);
var loginObj = function loginObj() {
  return {
    email: window.userInfo.email,
    tokenId: window.userInfo.accessToken,
    localId: window.userInfo.localId,
    domain: window.userInfo.domain
  };
};
export default {
  getVisualizationUserAccess: function getVisualizationUserAccess(data) {
    var login = loginObj();
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post('/tbl/user_access/visualizationUserAccess', body).then(function (res) {
      tasks.lockScreen.unlock();
      return res.data;
    }).catch(function (err) {
      console.info(err);
    });
  },
  reloadVisualizationUserAccess: function reloadVisualizationUserAccess(data) {
    var login = loginObj();
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post('/tbl/user_access/reloadVisualizationUserAccess', body).then(function (res) {
      tasks.lockScreen.unlock();
      return res.data;
    }).catch(function (err) {
      console.info(err);
    });
  },
  assignRolUser: function assignRolUser(data) {
    var login = loginObj();
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post('/tbl/user_access/assignRolUser', body).then(function (res) {
      tasks.lockScreen.unlock();
      return res.data;
    }).catch(function (err) {
      console.info(err);
    });
  },
  getTableauUserDP: function getTableauUserDP(data) {
    var login = loginObj();
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post('/tbl/user_access/getTableauUserDP', body).then(function (res) {
      tasks.lockScreen.unlock();
      return res.data;
    }).catch(function (err) {
      console.info(err);
    });
  },
  updateTableauUserDP: function updateTableauUserDP(data) {
    var login = loginObj();
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post('/tbl/user_access/updateTableauUserDP', body).then(function (res) {
      tasks.lockScreen.unlock();
      return res.data;
    }).catch(function (err) {
      console.info(err);
    });
  },
  deleteTableauUserDP: function deleteTableauUserDP(data) {
    var login = loginObj();
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post('/tbl/user_access/deleteTableauUserDP', body).then(function (res) {
      tasks.lockScreen.unlock();
      return res.data;
    }).catch(function (err) {
      console.info(err);
    });
  },
  downloadTableauUserDP: function downloadTableauUserDP(data) {
    var login = loginObj();
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post('/tbl/user_access/downloadTableauUserDP', body).then(function (res) {
      tasks.lockScreen.unlock();
      return res.data;
    }).catch(function (err) {
      console.info(err);
    });
  },
  logTableauRol: function logTableauRol(data) {
    var login = loginObj();
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post('/tbl/user_access/logTableauRol', body).then(function (res) {
      tasks.lockScreen.unlock();
      return res.data;
    }).catch(function (err) {
      console.info(err);
    });
  },
  getUserTableauByEmail: function getUserTableauByEmail(data) {
    var login = loginObj();
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post('/tbl/user_access/userTableauByEmail', body).then(function (res) {
      tasks.lockScreen.unlock();
      return res.data;
    }).catch(function (err) {
      console.info(err);
    });
  },
  checkUserHasAccess: function checkUserHasAccess(data) {
    var login = loginObj();
    var domain = window.userInfo.domain;
    var body = _objectSpread({
      login: login,
      domain: domain
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post('/tbl/user_access/checkUserHasAccess', body).then(function (res) {
      tasks.lockScreen.unlock();
      return res.data;
    }).catch(function (err) {
      console.info(err);
    });
  }
};

/*
  appApis.getVisualizationUserAccess = (data = {}) => {
    const login = loginObj()
    const body = { login, ...data }

    tasks.lockScreen.lock()
    return appApis.post('/visualizationUserAccess/', body).then(res => {
      tasks.lockScreen.unlock()
      return res.data
    }).catch(err => {
      console.info(err)
    })
  }

  appApis.reloadVisualizationUserAccess = (data = {}) => {
    const login = loginObj()
    const body = { login, ...data }

    tasks.lockScreen.lock()
    return appApis.post('/reloadVisualizationUserAccess/', body).then(res => {
      tasks.lockScreen.unlock()
      return res.data
    }).catch(err => {
      console.info(err)
    })
  }

  appApis.assignRolUser = (data = {}) => {
    const login = loginObj()
    const body = { login, ...data }

    tasks.lockScreen.lock()
    return appApis.post('/assignRolUser/', body).then(res => {
      tasks.lockScreen.unlock()
      return res.data
    }).catch(err => {
      console.info(err)
    })
  }

  appApis.getTableauUserDP = (data = {}) => {
    const login = loginObj()
    const body = { login, ...data }

    tasks.lockScreen.lock()
    return appApis.post('/getTableauUserDP/', body).then(res => {
      tasks.lockScreen.unlock()
      return res.data
    }).catch(err => {
      console.info(err)
    })
  }

  appApis.updateTableauUserDP = (data = {}) => {
    const login = loginObj()
    const body = { login, ...data }

    tasks.lockScreen.lock()
    return appApis.post('/updateTableauUserDP/', body).then(res => {
      tasks.lockScreen.unlock()
      return res.data
    }).catch(err => {
      console.info(err)
    })
  }

  appApis.deleteTableauUserDP = (data = {}) => {
    const login = loginObj()
    const body = { login, ...data }

    tasks.lockScreen.lock()
    return appApis.post('/deleteTableauUserDP/', body).then(res => {
      tasks.lockScreen.unlock()
      return res.data
    }).catch(err => {
      console.info(err)
    })
  }

  appApis.downloadTableauUserDP = (data = {}) => {
    const login = loginObj()
    const body = { login, ...data }

    tasks.lockScreen.lock()
    return appApis.post('/downloadTableauUserDP/', body).then(res => {
      tasks.lockScreen.unlock()
      return res.data
    }).catch(err => {
      console.info(err)
    })
  }

  appApis.logTableauRol = (data = {}) => {
    const login = loginObj()
    const body = { login, ...data }

    tasks.lockScreen.lock()
    return appApis.post('/logTableauRol/', body).then(res => {
      tasks.lockScreen.unlock()
      return res.data
    }).catch(err => {
      console.info(err)
    })
  }
  */